import { html, View } from 'rune-ts';
import { addHours, format, isBefore, startOfDay } from 'date-fns';
import { getFormattedRemainingCutoffTime } from '@modules/MShop/App/ProductDetail/S/Tmpl/partials/getFormattedRemainingCutoffTime.ts';
import ko from 'date-fns/locale/ko/index.js';
import enUS from 'date-fns/locale/en-US/index.js';
import ja from 'date-fns/locale/ja/index.js';
import klass from './ShipDateSectionView.module.scss';
import { classes } from '@services/MarppleShop/shared/util';
import { font } from '@services/MarppleShop/shared/typography';
import { ELang } from '@services/MarppleShop/shared/enum/ELang.ts';

type TProps = {
  shipDate: string | null;
  deliveryLeadTimePolicy: {
    delivery_mode: 'SAME_DAY' | 'BUSINESS_DAY' | null;
    cutoff_time: number | null;
    next_business_day: string;
    next_delivery_lead_time_policy_business_day: string | null;
  };
};

export class ShipDateSectionView extends View<TProps> {
  protected override onMount() {
    setInterval(() => {
      this.redraw();
    }, 1000);
  }

  protected override template({ deliveryLeadTimePolicy, shipDate }: TProps) {
    const locale = ET.lang === ELang.Kr ? ko : ET.lang === ELang.Jp ? ja : enUS;

    if (shipDate) {
      // 배송 출발일 - 특정 날짜
      return html`<div class="${klass.product_summary}">
        <span class="${classes(klass.section_title, font('14_bold', '12_bold'))}"
          >${ET('delivery_lead_time::product_detail::ship_date_title')}</span
        >

        <div class="${classes(klass.product_summary_detail, font('14_medium', '12_medium'))}">
          <span class="${classes(klass.production_date, font('14_bold', '12_bold'))}">
            ${format(new Date(shipDate), 'yyyy-MM-dd(EEE)', { locale })}
          </span>

          <span>${ET('delivery_lead_time::product_detail::ship_date_specific_date')}</span>
        </div>
      </div>`;
    } else if (deliveryLeadTimePolicy.delivery_mode === 'SAME_DAY' && deliveryLeadTimePolicy.cutoff_time) {
      // 배송정책과 동일 - 당일출발

      const cutoffTimeDate = addHours(startOfDay(new Date()), deliveryLeadTimePolicy.cutoff_time);

      if (isBefore(new Date(), cutoffTimeDate)) {
        const formattedRemainingCutoffTime = getFormattedRemainingCutoffTime(cutoffTimeDate);

        return html`<div class="${klass.product_summary}">
          <span class="${classes(klass.section_title, font('14_bold', '12_bold'))}"
            >${ET('delivery_lead_time::product_detail::ship_date_title')}</span
          >

          <div class="${classes(klass.product_summary_detail, font('14_medium', '12_medium'))}">
            <span class="${classes(klass.production_date, font('14_bold', '12_bold'))}">
              ${ET('delivery_lead_time::product_detail::ship_date_same_day', {
                day: format(new Date(), 'EEE', { locale }),
              })}
            </span>

            <span
              >${ET('delivery_lead_time::product_detail::ship_date_same_day_cutoff_time', {
                cutoff_time: formattedRemainingCutoffTime,
              })}
            </span>
          </div>
        </div>`;
      } else {
        return html`<div class="${klass.product_summary}">
          <span class="${classes(klass.section_title, font('14_bold', '12_bold'))}"
            >${ET('delivery_lead_time::product_detail::ship_date_title')}</span
          >

          <div class="${classes(klass.product_summary_detail, font('14_medium', '12_medium'))}">
            <span class="${classes(klass.production_date, font('14_bold', '12_bold'))}">
              ${format(new Date(deliveryLeadTimePolicy.next_business_day), 'yyyy-MM-dd(EEE)', {
                locale,
              })}</span
            >

            <span>${ET('delivery_lead_time::product_detail::ship_date_same_day_after')}</span>
          </div>
        </div>`;
      }
    } else if (
      deliveryLeadTimePolicy.delivery_mode === 'BUSINESS_DAY' &&
      deliveryLeadTimePolicy.next_delivery_lead_time_policy_business_day
    ) {
      // 배송 정책과 동일 - N 영업일 이내 출발

      return html`<div class="${klass.product_summary}">
        <span class="${classes(klass.section_title, font('14_bold', '12_bold'))}"
          >${ET('delivery_lead_time::product_detail::ship_date_title')}</span
        >

        <div class="${classes(klass.product_summary_detail, font('14_medium', '12_medium'))}">
          <span class="${classes(klass.production_date, font('14_bold', '12_bold'))}">
            ${format(
              new Date(deliveryLeadTimePolicy.next_delivery_lead_time_policy_business_day),
              'yyyy-MM-dd(EEE)',
              {
                locale,
              },
            )}</span
          >

          <span>${ET('delivery_lead_time::product_detail::ship_date_same_day_after')}</span>
        </div>
      </div>`;
    } else {
      return html`<div style="display: none"></div>`;
    }
  }
}
